// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceTree component
 */
!(function() {


  var React = require('react');
  var EventUtils = require('EventUtils');

  var m = require('mobx');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');

  var Panel = require('share/components/controls/Izenda.Panel');
  var List = require('share/components/controls/Izenda.List');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var CollapsibleList = require('share/components/controls/Izenda.CollapsibleList');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var SourceTreeItem = require('./Izenda.SourceTreeItem');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  const { isEmpty, isFunction } = require('lodash/fp');

  function createTreeItem(tree, store, props) {
    return function(node) {
      return (
        <SourceTreeItem
          key={node.id}
          node={node}
          store={store}
          filter={tree.filter.text}
          showCheckbox={props.showCheckbox}
          showIcon={props.showIcon}
          showSelected={props.showSelected}
        />
      );
    };
  }

  /**
   * check rules of display nodes/fields of QuerySourceTree
   * @param  {Object}  querySourceNode
   * @param  {Boolean} showFieldNode
   * @return {Boolean} should display TreeNode (true) or TreeItem (false)
   */
  function checkDisplayingNode(querySourceNode, showFieldNode) {
    // only display TreeNode if childNodes have items or this node is TypeGroup
    if (!isEmpty(querySourceNode.childNodes) || querySourceNode.isTypeGroup()) {
      // only display TreeNode if this node is FieldNode & showFieldNode is ON
      return (querySourceNode.isFieldNode && showFieldNode) || !querySourceNode.isFieldNode ? true : false;
    }
    return false;
  }

  /**
   * display TreeNode/TreeItem of QuerySourceTree
   * @param  {Object}  tree
   * @param  {Object}  store
   * @param  {Object}  querySourceNode
   * @param  {Object} props
   * @return {Object} TreeNode/TreeItem
   */
  function treeNode(tree, store, querySourceNode, props) {
    var treeItem = createTreeItem(tree, store, props);

    return checkDisplayingNode(querySourceNode, props.showFieldNode) ? (
      <CollapsibleList
        className="panel-group collapsible-list-items datasource"
        key={querySourceNode.id}
        autoCollapse={false}
        defaultExpand={true}
      >
        <CollapsibleList.Item expanded={true} key={querySourceNode.id}>
          <CollapsibleList.ItemHeader className="panel-heading">{treeItem(querySourceNode)}</CollapsibleList.ItemHeader>

          <CollapsibleList.ItemBody className="panel-body">
            <List className="list-group" key={querySourceNode.id}>
              {querySourceNode.childNodes.map(function(child) {
                return renderChildNode(querySourceNode, child);
              })}
            </List>
          </CollapsibleList.ItemBody>
        </CollapsibleList.Item>
      </CollapsibleList>
    ) : (
      treeItem(querySourceNode)
    );

    function renderChildNode(querySourceNode, child) {
      if (isFunction(props.showSelected)) {
        if (props.showSelected(child)) {
          return querySourceNode.isFieldNode ? treeItem(child) : treeNode(tree, store, child, props);
        } else {
          return null;
        }
      }

      return props.showSelected && !child.checked
        ? querySourceNode.isFieldNode
          ? treeItem(child)
          : null
        : treeNode(tree, store, child, props);
    }
  }

  function searchBox(tree, store) {
    var notifyChange = EventUtils.notifyChange;

    var invisibleClassName = classnames('search-box', {
      invisible: !store.item.haveDataSource
    });

    return (
      <div className="search-box">
        <SearchTextBox
          value={tree.filter.text}
          onChange={notifyChange(tree.setFilter.bind(tree), EventUtils.INPUT)}
          disabled={!store.item.haveDataSource}
        />
      </div>
    );
  }

  var SourceTree = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      tree: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired,
      showSelected: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.bool]),
      showCheckbox: React.PropTypes.bool,
      showFieldNode: React.PropTypes.bool,
      showIcon: React.PropTypes.bool
    },

    render: function() {
      var props = this.props;
      var store = props.store;
      var tree;

      if (props.isDataModel) {
        tree = store.item.querySourceTree;
      } else if (props.isTenant) {
        tree = store.item.selectedTenant.querySourceTree;
      } else if (props.isDestination) {
        tree = store.item.selectedTenant.destinationQuerySourceTree;
      }

      var title = props.localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE');

      var header = {
        component: Header,
        title: title,
        store: store,
        onChangeSourceDropDown: this.onChangeSourceDropDown,
        hideDropdown: props.hideDropdown
      };

      return (
        <Panel className="u_borderAll workspace-tree u_noMarginAll">
          {searchBox(tree, store)}
          <div className={classnames(props.className, 'workspace-tree-wraper')}>
            <ScrollBox>
              {tree.root.map(function(treeRootItem) {
                return treeRootItem.childNodes.map(function(node) {
                  if (isFunction(props.showSelected)) {
                    return props.showSelected(node) ? treeNode(tree, store, node, props) : null;
                  }

                  if (props.showSelected && !node.checked) {
                    return null;
                  }

                  return treeNode(tree, store, node, props);
                });
              })}
            </ScrollBox>
          </div>
        </Panel>
      );
    },

    onChangeSourceDropDown: m.action(function(sourceId) {
      var store = this.props.store;
      var loader = this.props.loader;

      loader.startLoading();
      store.item.updateDataForDestination(sourceId);
      store.item
        .updateSelectedTenantsForDestination(store.item.selectedDestinationTenantIDs, sourceId)
        .finally(loader.endLoading.bind(loader));
    })
  });

  var Header = React.createClass({
    render: function() {
      var props = this.props;
      return (
        <div>
          <span className="u_inlineBlock text-bold">{props.title}</span>
          {props.hideDropdown ? null : (
            <span className="u_inlineBlock padding-left">
              <DropDown
                options={props.store.tenantList}
                onChange={EventUtils.notifyChange(props.onChangeSourceDropDown, EventUtils.DROPDOWN)}
                value={props.store.item.sourceId}
                valueField="id"
                labelField="name"
              />
            </span>
          )}
        </div>
      );
    }
  });

  module.exports = connect()(SourceTree);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceTree/Izenda.SourceTree.jsx